import { useRef } from "react"

import { logger } from "../utils/monitoring/logging"
import { captureException } from "../utils/monitoring/monitoring"

type SDKEvent = "loading" | "loaded" | "finished" | "error"

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    webkit?: { messageHandlers?: { InstaCoverSDK?: { postMessage?: (o: any) => void } } }
    InstaCoverSDK?: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      postMessage?: (o: any) => void
    }
  }
}

export function isInSdk() {
  return !!window.InstaCoverSDK || !!window.webkit?.messageHandlers?.InstaCoverSDK
}

// TODO testy ze se to triggeruje
// tohle je pro mobilni sdkacko
export function useDispatchSDKEvent(event: SDKEvent, disabled?: boolean) {
  const wasDispatchedRef = useRef(false)

  if (disabled) {
    return
  }

  if (!wasDispatchedRef.current) {
    wasDispatchedRef.current = true

    try {
      const message = { name: event }
      if (window.webkit?.messageHandlers?.InstaCoverSDK?.postMessage) {
        logger.debug("dispatching SDK event", event)

        window.webkit.messageHandlers.InstaCoverSDK?.postMessage(message)
      }

      if (window.InstaCoverSDK?.postMessage) {
        logger.debug("dispatching SDK event", event)

        // musi to bejt takhle na jednom radku protoze android
        // a musi to bejt primitivni typ protoze primitivni android
        window.InstaCoverSDK.postMessage(JSON.stringify(message))
      }
    } catch (error) {
      logger.error("handled: Cannot dispatch SDK event", event, error)
      captureException(error)
    }
  }
}

type Props = {
  event: SDKEvent
  disabled?: boolean
}

export function DispatchSDKEvent(props: Props) {
  const { event, disabled } = props
  useDispatchSDKEvent(event, disabled)
  return null
}
